module.exports = __webpack_public_path__ + "img/defaultHandle.7e0116eb.svg";